// extracted by css-extract-rspack-plugin
export default {"main":"main-YmXTGo","menu":"menu-uNfBCt","menuHead":"menuHead-nwlk2t","mainList":"mainList-Xr0zF0"};// extracted by css-extract-rspack-plugin
export default {"main":"main-YmXTGo","menu":"menu-uNfBCt","menuHead":"menuHead-nwlk2t","mainList":"mainList-Xr0zF0"};